export default __webpack_public_path__ + "static/media/cadeado_fechado.fb78b3f6.svg";